module.exports = __webpack_public_path__ + "img/partner_img1.f64b4119.png";